import { Outlet } from "react-router";
import { FilterProvider } from "../../../context/FilterProvider";

const CaliforniaJACFilter = () => {
    return (
        <FilterProvider>
            <Outlet />
        </FilterProvider>
    );
}

export default CaliforniaJACFilter;